<template>
  <div>
    <common-dialog 
      ref="dialog" 
      width="800px" 
      title="查看 驾校合作模式" 
      edit-title 
      id-key="CoopId" 
      :data="data"
      form-label-width="85px" 
      :form-rules="rules" 
      :save-func="api.save" 
      :get-data-func="api.info" 
      close-on-saved
      @create-opened="onCreateOpened" 
      @edit-opened="onEditOpened" 
      @closed="onClosed" 
      :before-save="onBeforeSave"
      @details-opened="onDetailsOpened" 
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="归属机构" prop="DpId">
              {{data.DpName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合作模式" prop="CoopMode">
              {{data.CoopMode}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="签约时间" prop="SignDate">
              {{$commonJs.toDateString(data.SignDate)}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" prop="Status">
              {{data.Status==1?"正常":"终止"}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" v-if="data.Status==0">
            <el-form-item label="终止时间" prop="StopDate">
              {{$commonJs.toDateString(data.StopDate)}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <div>名额单价</div>
            <el-table ref="coopTable1" :data="data.opCoopDtsDtos" border size="small" style="width:100%;margin:10px 0;">
              <el-table-column prop="CarType" label="培训车型" align="center" min-width="80" />
              <el-table-column prop="Price" label="出库单价" width="120" align="center">
                <template slot-scope="{row}">
                  {{row.Price?row.Price+" 元":null}}
                </template>
              </el-table-column>
            </el-table>
          </el-col>

          <el-col :span="16" style="padding-left: 8px;">
            <div>计时单价</div>
            <el-table ref="coopTable2" :data="data.opCoopDtsDtos" border size="small" style="width:100%;margin:10px 0;">
              <el-table-column prop="CarType" label="培训车型" align="center" min-width="80" />
              <el-table-column prop="PracticeName" label="课程" width="80" align="center">
                实操
              </el-table-column>
              <el-table-column prop="PracticePrice" label="计时单价" width="120" align="center">
                <template slot-scope="{row}">
                  {{row.PracticePrice?row.PracticePrice+" 元":null}}
                </template>
              </el-table-column>
              <el-table-column prop="SimulateName" label="课程" width="80" align="center">
                模拟
              </el-table-column>
              <el-table-column prop="SimulatePrice" label="计时单价" width="120" align="center">
                <template slot-scope="{row}">
                  {{row.SimulatePrice?row.SimulatePrice+" 元":null}}
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <span v-if="data.ReviewTime">审批信息</span>
        <el-row class="row-border" v-if="data.ReviewTime">
          <el-col :span="12">
            <el-form-item label="审批人">
              {{data.ReviewUserName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="审批时间">
              {{data.ReviewTime}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="审批状态">
              <span v-if="data.ReviewStatus==0">草稿</span>
              <span v-else-if="data.ReviewStatus==1">待审批</span>
              <span v-else-if="data.ReviewStatus==2">退回</span>
              <span v-else-if="data.ReviewStatus==3">已审批</span>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="(data.ReviewStatus==0||data.ReviewStatus==2)&&data.ReviewTime">
            <el-form-item label="退回原因">
              {{data.ReviewRemark}}
            </el-form-item>
          </el-col>
        </el-row>
        其他信息
        <el-row class="row-border">
          <el-col :span="12">
            <el-form-item label="创建人">
              {{data.AddUserName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建时间">
              {{data.AddTime}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="修改人">
              {{data.UpdateUserName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="修改时间">
              {{data.UpdateTime}}
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template slot="footer" >
        <template v-if="$permission.canReview()">
          <el-button type="success" @click="pass" v-if="data.ReviewStatus==1">通 过</el-button>
          <el-button type="danger" @click="back(1)" v-if="data.ReviewStatus==1">退 回</el-button>
          <el-button type="danger" @click="back(2)" v-if="data.ReviewStatus==3">撤销审批</el-button>
        </template>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
    <return-dialog ref="returnDialog" @confirm="toReturn"></return-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import api from "@/api/op/coop";
import returnDialog from "@/components/schoolmanage/dp/returnDialog";

  export default {
    mixins: [editDialogMixin],
    components: {
      commonDialog,
      returnDialog
    },
    data() {
      return {
        data: {
          CoopId: 0,
          DpName: "",
          CoopMode: "",
          SignDate: "",
          StopDate: "",
          DpId: null,
          Status: 1,
          ReviewStatus: 0,
          opCoopDtsDtos: [],
          // ---------
          ReviewUserName: "",
          ReviewTime: "",
          ReviewRemark: "",
          AddUserName: "",
          AddTime: "",
          UpdateUserName: "",
          UpdateTime: "",
        },
        api,
        dpApi: require("@/api/basic/dp").default,
        rules: {
          SignDate: [{ required: true, message: "请选择签约时间" }],
          CoopMode: [{ required: true, message: "请选择合作模式" }],
          DpId: [{ required: true, message: "请选择所属组织" }],
          StopDate: [{ required: true, message: "请选择终止时间" }],
        }
      };
    },
    computed: {},
    methods: {
      onCreateOpened() {
        
      },
      onEditOpened(data) {
        
      },
      onDetailsOpened(row) {
        this.onEditOpened(row)
      },
      pass() {
        this.$confirm("确认通过吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.loading(true);
            this.api.pass({ Id: this.data.CoopId, Remark: "" }).then(res => {
              this.loading(false);
              if(res.Code==0) {
                this.$message.success("操作成功");
                this.close(true);
                this.$emit('close-saved');
              } else {
                this.$message.error(res.Msg);
              }
            })
          })
          .catch(() => {});
      },
      back(t) {
        this.backType = t;
        this.$refs.returnDialog.open(t);
      },
      toReturn(data) {
        this.loading(true);
        if(this.backType==1) {
          this.api.back({ Id: this.data.CoopId, Remark: data.Remark }).then(res => {
            this.loading(false);
            if(res.Code==0) {
              this.$message.success(res.Msg);
              this.close(true);
              this.$emit('close-saved');
            } else {
              this.$message.error(res.Msg);
            }
          })
        } else {
          this.api.cancelReview({ Id: this.data.CoopId, Remark: data.Remark }).then(res => {
            this.loading(false);
            if(res.Code==0) {
              this.$message.success(res.Msg);
              this.close(true);
              this.$emit('close-saved');
            } else {
              this.$message.error(res.Msg);
            }
          })
        }
      },
      onBeforeSave() {
      },
      onClosed() {
      }
    }
  };
</script>
<style lang="scss" scoped>

</style>